console.log("✅ custom.js is loaded correctly!"); // Test if the file is loading

document.addEventListener("DOMContentLoaded", function () {
    console.log("🚀 Script loaded!");

    const languageInput = document.querySelector("input[name='locale_code']");

    if (!languageInput) {
        console.log("❌ Language input not found!");
        return;
    }

    const selectedLanguage = languageInput.value;
    console.log("🌍 Detected language:", selectedLanguage);

    // If French is selected, set country to France and currency to EUR
    if (selectedLanguage.includes("fr")) {
        const currentUrl = new URL(window.location.href);

        // Shopify uses "?currency=EUR&country=FR" for correct country and currency selection
        let updated = false;

        if (!currentUrl.searchParams.get("currency") || currentUrl.searchParams.get("currency") !== "EUR") {
            console.log("💶 Setting currency to EUR...");
            currentUrl.searchParams.set("currency", "EUR");
            updated = true;
        }

        if (!currentUrl.searchParams.get("country") || currentUrl.searchParams.get("country") !== "FR") {
            console.log("🇫🇷 Setting country to France...");
            currentUrl.searchParams.set("country", "FR");
            updated = true;
        }

        if (updated) {
            window.location.replace(currentUrl.href);
        }
    }
});